<template>
  <div class="bg_gray">
    <Header navTitle="我的证书" navPath="/mobile/center"></Header>
    <div class="container">
      <div class="cert_item_common" v-if="certList.length > 0" v-for="item in certList" :key="item.id">
        <h3 class="text_ellipsis" :title="item.certificate.name">{{ item.certificate.name }}</h3>
        <p>证书编号：{{ item.serial_no }}</p>
        <p>发证日期：{{ item.created_at }}</p>
      </div>
      <van-empty v-else description="暂无内容哦~"/>
    </div>
  </div>
</template>

<script>
  import Header from 'components/mobile/common/Header'
  import {getUserCertificate} from "api/certificate/detail"
  import { checkIDCardNo } from 'utils/common.js'
  export default {
    components: {
      Header,
    },
    data() {
      return {
        certList: []
      }
    },
    mounted() {
      this.$emit('update:isShowHeader', false)
      this.getData()
    },
    methods: {
      getData(){
        getUserCertificate().then(result => {
          var data = result.data
          this.certList.push(...data)
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
.container {
  background: transparent;
}
</style>
